"use strict";

exports.__esModule = true;
exports.RealTimeDataItemChartV2Element = void 0;
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
var _react = _interopRequireWildcard(require("react"));
var _DeviceDataBatchSubscription = require("../../Device/DeviceDataBatchSubscription");
var _Device = require("../../Device");
var _getRealTimeValuesFromBatchPacket = require("../../Charts/getRealTimeValuesFromBatchPacket");
var _Timeline = require("../../Timeline");
var _dataConverter = require("./dataConverter");
var _Charts = require("../../Charts");
var _dataItemChartOptions = require("../../Echarts/Series/dataItemChartOptions");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _timeFormatters = require("../../Echarts/Series/timeFormatters");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var RealTimeDataItemChartV2Element = exports.RealTimeDataItemChartV2Element = function RealTimeDataItemChartV2Element(props) {
  var device = (0, _react.useContext)(_Device.DeviceContext);
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    uiModern = _useUiDesign.modern;
  var _useContext2 = (0, _react.useContext)(_Time.TimeContext),
    timezone = _useContext2.timezone;
  var dataItems = props.dataItems,
    duration = props.duration,
    frequency = props.frequency,
    options = props.options,
    downloadDataItemData = props.downloadDataItemData,
    width = props.width,
    height = props.height,
    targetValue = props.targetValue;
  var _useState = (0, _react.useState)({}),
    itemsDict = _useState[0],
    setItemsDict = _useState[1];
  var _useState2 = (0, _react.useState)({}),
    optionsState = _useState2[0],
    setOptionsState = _useState2[1];
  var echartsRef = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    var tmpItemsDict = {};
    for (var i = 0; i < dataItems.length; i++) {
      var di = dataItems[i];
      tmpItemsDict[device.uuid + "-" + di.name] = i;
    }
    setItemsDict(tmpItemsDict);
  }, [dataItems]);
  (0, _react.useEffect)(function () {
    var _seriesInit;
    var now = new Date().getTime();
    var seriesInit = (_seriesInit = {}, _seriesInit[device.uuid] = {}, _seriesInit);
    dataItems.forEach(function (di) {
      return seriesInit[device.uuid][di.name] = [[now, 0]];
    });
    setOptionsState((0, _dataItemChartOptions.createDataItemEChartProps)({
      series: seriesInit,
      device: device,
      dataItems: dataItems,
      options: options,
      timezone: timezone,
      translate: translate,
      useZeroAsBase: false,
      xAxisFormatter: _timeFormatters.realTimeXAxisFormatter,
      downloadCSVData: function downloadCSVData(deviceName, data) {
        return downloadDataItemData(deviceName, data);
      },
      targetValue: targetValue,
      uiModern: uiModern
    }));
  }, [options, dataItems]);
  var updateSeriesInOptions = function updateSeriesInOptions(timelines) {
    var data = (0, _dataConverter.convertRealTimeDataFromTimelines)(timelines, device.uuid, dataItems);
    if (echartsRef && echartsRef.current && echartsRef.current.getEchartsInstance) {
      echartsRef.current.getEchartsInstance().setOption({
        series: options.chartItems.props.reduce(function (acc) {
          data.forEach(function (d) {
            return acc.push(d);
          });
          return acc;
        }, []).map(function (d) {
          return {
            data: d
          };
        })
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_DeviceDataBatchSubscription.DeviceDataItemBatchSubscription, {
    deviceUuid: device.uuid,
    dataItems: dataItems
  }, function (packet) {
    return /*#__PURE__*/_react["default"].createElement(_Timeline.SlidingInterval, {
      duration: duration,
      frequency: frequency
    }, function (interval) {
      return /*#__PURE__*/_react["default"].createElement(_Timeline.SlidingTimeline, {
        interval: interval,
        latestValues: (0, _getRealTimeValuesFromBatchPacket.getRealTimeValuesFromBatchPacket)(packet, dataItems.length, itemsDict)
      }, function (timelines) {
        updateSeriesInOptions(timelines);
        return /*#__PURE__*/_react["default"].createElement("div", {
          "data-testid": "RealTimeDataItemChartV2Element.chart"
        }, (options == null ? void 0 : options.chartItems) && /*#__PURE__*/_react["default"].createElement(_Charts.ReactEChartsLineChart, {
          echartRef: echartsRef,
          width: width,
          options: optionsState,
          height: height,
          timezone: timezone
        }));
      });
    });
  });
};